export const SUBURBS = [
  {
    slug: "robina",
    name: "Robina",
    region: "Central Gold Coast",
    intro: "Robina is one of the Gold Coast's busiest family hubs — big carpeted homes, townhouses around the town centre, and a steady flow of rentals near Bond University. Busy households mean carpets, couches and rugs that work hard every day.",
    body: "Kay's Carpet Cleaning regularly works in Robina homes and townhouses, from multi-level carpeted layouts to media-room couches and well-loved family rugs. Whether it's a routine refresh or a specific stain that's been bothering you, we'll assess the job and give you a straight answer on what's achievable.",
    points: [
      "Carpet cleaning for multi-level homes, stairs and rumpus rooms",
      "Couch and rug cleaning for busy family living areas",
      "Move-in and move-out style refreshes for rental properties",
    ],
    nearby: ["varsity-lakes", "mudgeeraba", "burleigh-heads"],
  },
  {
    slug: "burleigh-heads",
    name: "Burleigh Heads",
    region: "Coastal Gold Coast",
    intro: "Beachside living is hard on soft furnishings. Sand, salt air and humidity all find their way into Burleigh Heads homes — and into carpets, rugs and couches.",
    body: "From beach houses to apartments above the Esplanade, we help Burleigh Heads locals keep carpets and upholstery fresh despite the coastal lifestyle. Sand acts like fine grit in carpet pile, so regular professional cleaning genuinely extends the life of floor coverings here.",
    points: [
      "Carpet cleaning that lifts tracked-in sand and beachside grit",
      "Rug cleaning for homes with timber floors and area rugs",
      "Couch and lounge cleaning for coastal units and beach houses",
    ],
    nearby: ["palm-beach", "mermaid-beach", "robina"],
  },
  {
    slug: "southport",
    name: "Southport",
    region: "Northern Gold Coast",
    intro: "Southport mixes older Queenslander-style homes, Broadwater apartments and a growing professional precinct — which means a real variety of cleaning jobs.",
    body: "We work across Southport's older homes, modern units and commercial spaces. Apartment customers often ask about access and lifts — just mention it when you request your estimate and we'll plan around it.",
    points: [
      "Carpet and rug cleaning for older homes and units alike",
      "Mattress cleaning for households, students and shared accommodation",
      "Commercial carpet cleaning for Southport offices and professional suites",
    ],
    nearby: ["labrador", "biggera-waters", "surfers-paradise"],
  },
  {
    slug: "broadbeach",
    name: "Broadbeach",
    region: "Coastal Gold Coast",
    intro: "Broadbeach's apartment towers and holiday units see constant foot traffic — sandy feet, suitcases and guests in rotation. Carpets and upholstery here work harder than most.",
    body: "Kay's Carpet Cleaning services Broadbeach apartments, holiday units and homes with professional carpet, couch and mattress cleaning. We coordinate around building access and lift bookings — just let us know the arrangements when you get in touch.",
    points: [
      "Carpet cleaning for high-rise apartments and holiday units",
      "Mattress and upholstery cleaning between guests or tenants",
      "Pet stain and odour treatment for pet-friendly stays",
    ],
    nearby: ["surfers-paradise", "mermaid-beach", "robina"],
  },
  {
    slug: "surfers-paradise",
    name: "Surfers Paradise",
    region: "Coastal Gold Coast",
    intro: "Surfers Paradise is high-rise territory — holiday apartments, short-stay units and investment properties with carpets that see thousands of sandy footsteps a year.",
    body: "We're set up for apartment work: building access, lifts and parking are all part of the conversation when you book. From a single holiday unit refresh to carpet cleaning across an investment property, we assess the job and provide an honest estimate.",
    points: [
      "High-rise apartment carpet cleaning with lift and access coordination",
      "Couch and mattress cleaning for holiday and short-stay units",
      "Tile and grout cleaning for beachside kitchens and bathrooms",
    ],
    nearby: ["broadbeach", "southport", "mermaid-beach"],
  },
  {
    slug: "palm-beach",
    name: "Palm Beach",
    region: "Coastal Gold Coast",
    intro: "Palm Beach has some of the Gold Coast's most loved beach houses and pet-friendly homes — and where pets and beach life combine, carpets and couches need regular professional attention.",
    body: "Pet accidents, sandy paws and everyday family living are the most common reasons Palm Beach customers call us. We'll assess stains and odours honestly and tell you what result to expect before any work begins.",
    points: [
      "Pet stain and odour treatment for carpets, rugs and couches",
      "Carpet cleaning for beach houses and family homes",
      "Rug cleaning with fibre-appropriate care",
    ],
    nearby: ["burleigh-heads", "currumbin", "tugun"],
  },
  {
    slug: "mermaid-beach",
    name: "Mermaid Beach",
    region: "Coastal Gold Coast",
    intro: "Mermaid Beach blends renovated beach shacks, modern townhouses and apartments — many with timber floors softened by rugs, and lounges that cop the coastal lifestyle.",
    body: "Rugs over timber, upholstered lounging and the occasional wet-dog afternoon are familiar jobs for us in Mermaid Beach. Every rug is assessed for fibre and construction before we clean it, so delicate pieces get the care they need.",
    points: [
      "Rug cleaning for area rugs over timber and tile floors",
      "Couch and upholstery cleaning for coastal living rooms",
      "Carpet cleaning for townhouses and apartments",
    ],
    nearby: ["mermaid-waters", "broadbeach", "burleigh-heads"],
  },
  {
    slug: "varsity-lakes",
    name: "Varsity Lakes",
    region: "Central Gold Coast",
    intro: "Varsity Lakes townhouses and units turn over regularly — students, young professionals and growing families all keep local carpets busy.",
    body: "Whether you're moving out and want the carpets refreshed, moving in and want a proper clean first, or staying put and dealing with a stain, Kay's Carpet Cleaning provides straightforward estimates for Varsity Lakes homes.",
    points: [
      "Carpet cleaning for townhouses and units, including stairs",
      "Move-in / move-out style cleans for rental turnovers",
      "Mattress cleaning for a genuinely fresh start",
    ],
    nearby: ["robina", "reedy-creek", "mudgeeraba"],
  },
  {
    slug: "mudgeeraba",
    name: "Mudgeeraba",
    region: "Central Gold Coast",
    intro: "Mudgeeraba's larger family homes and hinterland-fringe properties collect a different kind of dirt — red soil after rain, pets with big yards, and high-traffic family living.",
    body: "Bigger homes mean more carpet, and we plan Mudgeeraba jobs around the whole layout: bedrooms, living areas, hallways and stairs. Country-adjacent living also means we see plenty of rug and upholstery work here.",
    points: [
      "Whole-home carpet cleaning for larger family floor plans",
      "Rug and couch cleaning for homes with pets and acreage lifestyles",
      "Tile and grout cleaning for big kitchens and outdoor-adjacent areas",
    ],
    nearby: ["robina", "tallai", "bonogin"],
  },
  {
    slug: "hope-island",
    name: "Hope Island",
    region: "Prestige & Estate Areas",
    intro: "Hope Island's prestige homes and resort-style estates feature generous carpeted areas, quality rugs and upholstery that deserve careful, professional treatment.",
    body: "For larger prestige properties we take the time to assess each area properly — fibres, condition and any staining — before recommending an approach. Expect careful work and honest advice, whether it's a full-home carpet clean or a single treasured rug.",
    points: [
      "Careful carpet cleaning for large prestige homes",
      "Rug cleaning with assessment-first care for quality pieces",
      "Couch, lounge and mattress cleaning across the whole property",
    ],
    nearby: ["paradise-point", "runaway-bay", "sanctuary-cove"],
  },
  {
    slug: "coomera",
    name: "Coomera",
    region: "Northern Gold Coast",
    intro: "Coomera's new estates are full of young families — and new carpets meeting their first pets, spills and toddler years.",
    body: "Many Coomera customers call us for their home's first professional clean. It's a smart move: removing embedded grit early helps new carpet wear evenly and last longer. Pet accidents and playtime stains are everyday jobs for us here.",
    points: [
      "First professional cleans for new-estate carpets",
      "Pet stain and odour treatment for young family homes",
      "Couch and rug cleaning for busy living areas",
    ],
    nearby: ["oxenford", "helensvale", "upper-coomera"],
  },
  {
    slug: "tweed-heads",
    name: "Tweed Heads",
    region: "Coastal Gold Coast",
    intro: "Right on the border, Tweed Heads mixes units, family homes and retiree living — all in a humid coastal climate where carpets and upholstery benefit from regular professional care.",
    body: "Kay's Carpet Cleaning services Tweed Heads and the surrounding border area with the same approach we bring everywhere: assess first, clean appropriately for the material, and give honest expectations about stains and odours.",
    points: [
      "Carpet cleaning for units, townhouses and family homes",
      "Mattress cleaning for hygiene and freshness",
      "Water damage assistance during storm and wet-weather events",
    ],
    nearby: ["banora-point", "coolangatta", "tugun"],
  },
];

export const SUBURB_SLUGS = SUBURBS.map((s) => s.slug);
export const getSuburb = (slug) => SUBURBS.find((s) => s.slug === slug);
